var shifts = [
  // { "label": "نامشخص", value: 0 },
  { "text": "شیفت 1", value: 1 },
  { "text": "شیفت 2", value: 2 },
  { "text": "شیفت 3", value: 3 },
];

export default shifts;
